export default {
  // 查询保证金列表
  selectYxUserDepositByList: '/ygsjzs/yxUserDeposit/selectYxUserDepositByList',
  // 查询保证金详情
  selectYxUserDepositByDepositId: '/ygsjzs/yxUserDeposit/selectYxUserDepositByDepositId',
  // 查询保证金流水列表
  selectYxDepositTransactionByList: '/ygsjzs/yxUserDeposit/selectYxDepositTransactionByList',
  // 导出
  exportYxDepositTransaction: '/ygsjzs/yxUserDeposit/exportYxDepositTransaction',
  selectYxDepositGoodsByList: '/ygsjzs/yxUserDeposit/selectYxDepositGoodsByList',
  exportYxDepositGoods: '/ygsjzs/yxUserDeposit/exportYxDepositGoods',

  // 收益保证金调整
  insertYxUserDepositRecord: '/ygsjzs/yxUserDeposit/insertYxUserDepositRecord'
}
